import Head from "next/head";
import DefaultLayout from "@/components/DefaultLayout";
import styles from "@/styles/article/deliveryBrand.module.scss";
import ArticleTemplate from "@/components/article/ArticleTemplate";
import SliderBarLeft from "@/components/SliderBarLeft";
import SliderBarRight from "@/components/SliderBarRight";
import { usePathname } from "next/navigation";

export default function LegalAfterpay() {
  const pathname = usePathname();
  const articleName = pathname.split("/").pop() || "afterpay";

  return (
    <>
      <Head>
        <title>
          Online Shopping in New Zealand: Discount Store - BestDeals.co.nz
        </title>
        <meta name="keywords" content=""></meta>
        <meta
          name="description"
          content="Offers the best online shopping in New Zealand with cheap deals on home & garden, appliances, pet supplies, fitness equipment & much more online. Check out our daily sales now!"
        ></meta>
      </Head>

      <DefaultLayout>
        <div className={`${styles["page-delivery-brand"]} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <ArticleTemplate articleName={articleName} />
        </div>
      </DefaultLayout>
    </>
  );
}
